import {createRouter, createWebHistory} from "vue-router";

import Home from "./components/pages/Home";
import Properties from "./components/pages/Properties";
import Contact from "./components/pages/Contact";
import PropertySingle from "./components/pages/PropertySingle";
import Register from "./components/pages/Register";
import SubmitProperty from "./components/pages/SubmitProperty";
import EditProfile from "./components/pages/user/EditProfile";
import ChangePassword from "./components/pages/user/ChangePassword";
import MyProperties from "./components/pages/user/MyProperties";
import Favorites from "./components/pages/user/Favorites";
import EditProperty from "./components/pages/user/EditProperty";
import Profile from "./components/pages/user/Profile";
import Agencies from "./components/pages/Agencies";
import AgencySingle from "./components/pages/AgencySingle";

import {useAuthStore} from "./store/auth";
import AgencyProfile from "./components/pages/user/AgencyProfile";
import EditAgency from "./components/pages/user/EditAgency";

const routes = [
    {path: '/', name: 'home', component: Home},
    {path: '/properties', component: Properties},
    {path: '/agency-search', component: Agencies},
    {path: '/register', name: 'register', component: Register},
    {path: '/property/:id/:slug', component: PropertySingle},
    {path: '/agency/:id/:slug', component: AgencySingle},
    {path: '/submit-property', component: SubmitProperty, meta: {
            requiresAuth: true,
        }},
    {path: '/contact', component: Contact},
    {path: '/user/edit-profile', component: EditProfile, meta: {
            requiresAuth: true,
        }
    },
    {path: '/user/change-password', component: ChangePassword, meta: {
            requiresAuth: true,
        }},
    {path: '/user/my-properties', component: MyProperties, meta: {
            requiresAuth: true,
        }},
    {path: '/user/edit-property/:id', component: EditProperty, meta: {
            requiresAuth: true,
        }},
    {path: '/user/fav', component: Favorites, meta: {
            requiresAuth: true,
        }},
    {path: '/user/profile', component: Profile, meta: {
            requiresAuth: true,
        }
    },
    {path: '/user/agency', component: AgencyProfile, meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/user/edit-agency', component: EditAgency, meta: {
            requiresAuth: true
        }
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach(async (to, from) => {
    const store = useAuthStore();

    const authenticated = store.$state.signedIn;
    const user = store.$state.user;

    if (to.matched.some((record) => record.meta.requiresAuth)) {

        if (!authenticated || !user) {
            return { name: 'register' };
        }
    }

    if(to.name === 'register' && authenticated && user) {
        return { name: 'home' };
    }

    return true;
});

export default router;
